import breakPoints from '../../styles/_breakpoints.module.scss';

const MIN_WIDTH = 'min-width';
const MAX_WIDTH = 'max-width';
const AND = 'and';

const generateMinMaxWidthMediaQuery = (min, max) => `(${MIN_WIDTH}: ${min}) ${AND} (${MAX_WIDTH}: ${max})`;

export const isTabletQuery = generateMinMaxWidthMediaQuery(breakPoints.tabletMinWidth, breakPoints.tabletMaxWidth);
export const isMobileQuery = generateMinMaxWidthMediaQuery(breakPoints.mobileMinWidth, breakPoints.mobileMaxWidth);
export const isDesktopQuery = generateMinMaxWidthMediaQuery(breakPoints.desktopMinWidth, breakPoints.desktopMaxWidth);
